module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = rowResourceData || {}\nconst attributes = data.attributes || {}\nconst isAdvertisedAt = attributes.isAdvertisedAt\n// TODO: LOAD reactions data\nconst reactions = []\nif(attributes.isAdvertised){\nconst summary = attributes.projectTermJobStatusSummary || {}\nlet colorClass\nfor(const type in summary){\ncolorClass = undefined\nif(type === 'yes'){\ncolorClass = 'green'\n} else if(type === 'no'){\ncolorClass = 'red'\n}\nreactions.push({\ntype,\ncolorClass,\ncount: summary[type] || 0\n})\n}\n}\n%><div><%\nif(attributes.isAdvertised){\n%><label>vom <%= utils.moment(isAdvertisedAt).format('DD.MM.YYYY') %></label><%\n%><div class=\"reactions\"><%\nfor(const r in reactions){\nconst reaction = reactions[r] || {}\n%><div class=\"reactionGroup <%= reaction.colorClass %>\"><span><%= reaction.count %> <%= storage.__(`table.projectTermJobs.fields.advertisement.reaction.${reaction.type}`) %></span><%= (r < reactions.length - 1 ? ' | ' : '') %></div><%\n}\n%></div><%\n}\n%></div>"
  , __filename = "components/templates/office/projectTermJobs/tableFields/advertisement.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = rowResourceData || {}
const attributes = data.attributes || {}
const isAdvertisedAt = attributes.isAdvertisedAt
// TODO: LOAD reactions data
const reactions = []
if(attributes.isAdvertised){
const summary = attributes.projectTermJobStatusSummary || {}
let colorClass
for(const type in summary){
colorClass = undefined
if(type === 'yes'){
colorClass = 'green'
} else if(type === 'no'){
colorClass = 'red'
}
reactions.push({
type,
colorClass,
count: summary[type] || 0
})
}
}

    ; __line = 24
    ; __append("<div>")
    ; 
if(attributes.isAdvertised){

    ; __line = 26
    ; __append("<label>vom ")
    ; __append(escapeFn( utils.moment(isAdvertisedAt).format('DD.MM.YYYY') ))
    ; __append("</label>")
    ; 

    ; __line = 27
    ; __append("<div class=\"reactions\">")
    ; 
for(const r in reactions){
const reaction = reactions[r] || {}

    ; __line = 30
    ; __append("<div class=\"reactionGroup ")
    ; __append(escapeFn( reaction.colorClass ))
    ; __append("\"><span>")
    ; __append(escapeFn( reaction.count ))
    ; __append(" ")
    ; __append(escapeFn( storage.__(`table.projectTermJobs.fields.advertisement.reaction.${reaction.type}`) ))
    ; __append("</span>")
    ; __append(escapeFn( (r < reactions.length - 1 ? ' | ' : '') ))
    ; __append("</div>")
    ; 
}

    ; __line = 32
    ; __append("</div>")
    ; 
}

    ; __line = 34
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/office/projectTermJobs/tableFields/advertisement.ejs

}